import React from 'react'

const HeaderSeparator = () => {
  return <div>|</div>
}

export default HeaderSeparator
